import React, { Component } from "react";
import { PostData } from "../../../../service/postData";
import { sendNotification } from "../../../../_notificationSettings/notificationPanel";
import { MDBDataTableV5 } from "mdbreact";
import { numberFormat } from "../../../../config/numberFormat";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import moment from "moment";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import { PaginationControl } from 'react-bootstrap-pagination-control';
import { Link } from 'react-router-dom'; 
import DownloadBtnSaleInvoicePdf from "../../Invoices/Sale/DownloadBtnSaleInvoicePdf";
import PrintBtnSaleInvoicePdf from "../../Invoices/Sale/PrintBtnSaleInvoicePdf";
import DownloadBtnSaleReturnInvoicePdf from "../../Invoices/SaleReturn/DownloadBtnSaleReturnInvoicePdf";
import PrintBtnSaleReturnInvoicePdf from "../../Invoices/SaleReturn/PrintBtnSaleReturnInvoicePdf";

let _UserSession = localStorage.getItem("vs_UserSession");
let _signingId = "0";
let _businessId = "0";
let _companyId = "0";

if (_UserSession!=undefined || _UserSession!=null) {
  _UserSession = JSON.parse(_UserSession);
  _signingId = _UserSession.loginId;
  _businessId = _UserSession.tokenKey;
}
 
let _companySession = localStorage.getItem("vs_UserCompanySession");
if (_companySession!=undefined || _companySession!=null) {
  _companySession = JSON.parse(_companySession);
  _businessId = _companySession.business_id;
  _companyId = _companySession.company_id;
}

let columns = [
  {
    label: '#',
    field: 'srNo',
    width: 20,
    attributes: {
    'aria-controls': 'DataTable',
    'aria-label': '#',
    },
  },
  {
    label: "Date",
    field: "date",
    width: 100,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Date",
    },
  },
  // {
  //   label: "TXN TYPE",
  //   field: "txn_type",
  //   width: 150,
  //   attributes: {
  //     "aria-controls": "DataTable",
  //     "aria-label": "TXN TYPE",
  //   },
  // },
  // {
  //   label: "Ref No.",
  //   field: "ref_no",
  //   width: 150,
  //   attributes: {
  //     "aria-controls": "DataTable",
  //     "aria-label": "Ref No.",
  //   },
  // },
  {
    label: "Sale Quantity",
    field: "sale_quantity",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Sale Quantity",
    },
  },
  {
    label: "Purchase Quantity",
    field: "purchase_quantity",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Purchase Quantity",
    },
  },
  {
    label: "Closing Quantity",
    field: "closing_quantity",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Closing Quantity",
    },
  },
  // {
  //   label: "Total Amount",
  //   field: "total_amount",
  //   width: 150,
  //   attributes: {
  //     "aria-controls": "DataTable",
  //     "aria-label": "Total Amount",
  //   },
  // },
];

let _loader = "glb-ldr-prt active";
let _currentYear = moment().format("YYYY");
let _startDateYaer = "01/01/" + _currentYear;
let _endDateYaer = "12/31/" + _currentYear;

export default class dayBookReportPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoaded: true,
      transactionArray: [],
      transactionArrayFilter: [],
      itemArrayTransaction: [],
      activeTransactionKey: "ALL",
      businessId: _businessId,
      company_id: _companyId,
      userId: _signingId,
      name: null,
      itemList: [],        // All item names fetched on load
      selectedItemId: "",  // The selected item_id from dropdown
      startDate : moment().startOf('month').format('YYYY-MM-DD'),
      endDate : moment().endOf('month').format('YYYY-MM-DD'),
      dateLabel: "",
      item_id : 0,
      pageCount : 25,
      page : 1,
      totalCount  : 0,
      pageShow  : 0,
      errors: {
        name: "",
      },
    };
  }

  async componentDidMount() {
    this.getItemList();
    if(this.state.item_id > 0){
      this.getSaleListData(this.state.item_id);
    }
  }
  getItemList = () => {
    const requestData = JSON.stringify({
      company_id: this.state.company_id,
    });

    PostData(global.userItemList, requestData, "POST").then((result) => {
      if (result.success && result.response) {
        this.setState({ itemList: result.response });
      } else {
        this.setState({ itemList: [] });
      }
    });
  };

  getItemSearch = (event) => {
      event.preventDefault();
      const { name, value } = event.target;
      let _valueSend = value;
      //console.log("==value==",parseInt(value));return;
      this.setState({item_id:_valueSend})
      if(_valueSend.length >= 3 || _valueSend == ''){
        this.getSaleListData(_valueSend,this.state.page,this.state.pageCount);
      }
  }

  getSaleListData(item_id,_page,pageCount) {
    console.log("==item_id==",item_id)
    let _transArray = [];
    const requestData = JSON.stringify({
      business_id: this.state.businessId,
      company_id: this.state.company_id,
      start_date: this.state.startDate,
      end_date: this.state.endDate,
      item_id: item_id, //this.state.activeItemId
      pageCount: pageCount,
      page:_page
    });

    PostData(global.itemDetailReport, requestData, "POST")
      .then((result) => {
        let responseJson = result;
        if (responseJson.success == false) {
          this.setState({ itemArrayTransaction: _transArray, isLoaded: true });
        } else {
          if (responseJson.response) {
            _transArray = responseJson.response;
          }
          this.setState({ itemArrayTransaction: _transArray, isLoaded: true,totalCount:responseJson.totalCount,pageShow:responseJson.pageShow });
        }
      })
      .catch((error) => this.setState({ error, isLoaded: false }));
  }

  loadTranscListing() {
    /*let dataList = { columns: columns, rows: [] };

    let _i=0;
    if (this.state.isLoaded) {
      let _transDetails = this.state.itemArrayTransaction;
      if (_transDetails.length > 0) {
        let rows = _transDetails.map((value, index) => ({
          srNo: ((_pageAK - 1) * this.state.pageCount) + _i,
          date: value.invoice_date,
          sale_quantity: value.total_quantity,
          adjust_quantity: 0,
          total_amount: numberFormat(value.total_amount),
        }));
        dataList.rows = rows;
      }
    }
    return dataList;*/
    
      let dataList = [];
      let rows = [];    
      let _i=0;
      if (this.state.isLoaded == true) {
        let _itemArrayTransaction = this.state.itemArrayTransaction;
        if (_itemArrayTransaction.length > 0) {
          _itemArrayTransaction.map((value, index) => {
          _i++; 
          let _pageAK = 1;
          let _total_quantity= 0;
          let _total_pur_quantity= 0;
          if(value.type === 'SALE'){
            _total_quantity = value.total_quantity;
          }else if(value.type === 'PURCHASE'){
            _total_pur_quantity = value.total_quantity;            
          } 
          rows.push({
            srNo: ((_pageAK - 1) * this.state.pageCount) + _i,
            date: moment(value.invoice_date).format("YYYY-MM-DD"),
            sale_quantity: value.sale_qty,
            purchase_quantity: value.purchase_qty,
            closing_quantity: value.closing_qty,
            total_amount: numberFormat(value.total_amount),
          });
        
          });
        }
      }
      if (rows) {
        dataList = {
          columns: columns,
          rows: rows,
        };
      }
      return dataList;
  }

  handleCallBackDate = (start, end) => {
    this.setState({
      startDate: start.format("YYYY-MM-DD"),
      endDate: end.format("YYYY-MM-DD"),
    });
    this.getSaleListData(this.state.item_id,this.state.page, this.state.pageCount);
  };

  clickToDelete(value, type) {
    confirmAlert({
      title: "Confirm to delete",
      message: "Are you sure you want to delete?",
      buttons: [
        {
          label: "Yes",
          className: "btn btn-danger",
          onClick: () => {
            const requestData = JSON.stringify({
              sale_id: value,
              type_value: type,
            });
            PostData(global.deleteSaleTransaction, requestData, "POST").then(
              (result) => {
                let responseJson = result;
                if (responseJson.success == false) {
                  sendNotification(
                    "Error Message 😓",
                    responseJson.message,
                    "danger"
                  );
                  return;
                } else {
                  sendNotification(
                    "Success Message 👍",
                    responseJson.message,
                    "success"
                  );
                  this.getSaleListData(this.state.item_id,this.state.page, this.state.pageCount);
                  return;
                }
              }
            );
          },
        },
        {
          label: "No",
          className: "btn btn-primary",
        },
      ],
    });
  }

  handleItemChange = (event) => {
    const itemId = event.target.value;
    console.log("==itemId==",itemId);
    this.setState({ item_id: parseInt(itemId),selectedItemId: parseInt(itemId)});

    if (itemId > 0) {
      this.getSaleListData(itemId,this.state.page, this.state.pageCount);
    }
  };

  render() {
    if (this.state.isLoaded == true) {
      _loader = "glb-ldr-prt";
    }
    const { errors } = this.state;
    return (
      <React.Fragment>
        <div className="content">
          <div className="block">
            <div className="row">
              <div className="col-md-12">
                <h5># Item Detail Report</h5>
                <div className="block">
                  <div className="block-content" style={{ marginTop: "-20px" }}>
                    <div className="row items-push">
                      <div className="row col-lg-12">
                        <div className="col-lg-9">
                          <span>Filter : </span>
                          <DateRangePicker
                            initialSettings={{
                              startDate: this.state.startDate,
                              endDate: this.state.endDate,
                              locale: {
                                format: "YYYY-MM-DD",
                              },
                              ranges: {
                                Today: [moment().toDate(), moment().toDate()],
                                Yesterday: [
                                  moment().subtract(1, "days").toDate(),
                                  moment().subtract(1, "days").toDate(),
                                ],
                                "This Week": [
                                  moment()
                                    .startOf("week")
                                    .format("YYYY-MM-DD"),
                                  moment().endOf("week").format("YYYY-MM-DD"),
                                ],
                                "This Month": [
                                  moment().startOf("month").toDate(),
                                  moment().endOf("month").toDate(),
                                ],
                                "Last Month": [
                                  moment()
                                    .subtract(1, "month")
                                    .startOf("month")
                                    .toDate(),
                                  moment()
                                    .subtract(1, "month")
                                    .endOf("month")
                                    .toDate(),
                                ],
                                "This Quarter": [
                                  moment().startOf("month").toDate(),
                                  moment()
                                    .add(2, "month")
                                    .endOf("month")
                                    .toDate(),
                                ],
                                "This Financial Year": [
                                  moment()
                                    .month("April")
                                    .startOf("month")
                                    .format("YYYY-MM-DD"),
                                  moment()
                                    .add(1, "year")
                                    .month("March")
                                    .endOf("month")
                                    .format("YYYY-MM-DD"),
                                ],
                              },
                            }}
                            onCallback={this.handleCallBackDate}
                          >
                            <input
                              type="text"
                              className="form-control col-7"
                              style={{ display: "inline-block" }}
                            />
                          </DateRangePicker>
                        </div>
                        {/* <div className="col-lg-3">
                          <div className="row pb-20 pull-right">
                            <div className="text-right">
                              <div className="js-appear-enabled text-center">
                                <div className="text-info">
                                  <i className="fa fa-file-excel-o"></i>
                                </div>
                                <div className="font-size-sm text-muted">
                                  Excel Export
                                </div>
                              </div>
                            </div>
                          </div>
                        </div> */}
                        <br />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="block" style={{ marginTop: "-60px" }}>
            <div className="row">
              <div className="col-md-12">
                <div className="block">
                  <div className="block-content">
                    <h2 className="block-title ml-10">Select an Item</h2>
                    <div className="form-group col-md-6">
                        <select
                          className="form-control"
                          value={this.state.selectedItemId}
                          onChange={(e) => this.handleItemChange(e)}
                        >
                          <option>Select an Item</option>
                        {this.state.itemList.map((item) => (
                          <option key={item.item_id} value={item.item_id}>
                            {item.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="block-content" id="tableData">
                    <MDBDataTableV5
                      hover
                      span
                      displayEntries={false}
                      entries={100}
                      pagingTop={false}
                      searchTop={false}
                      searchBottom={false}
                      info={false}
                      barReverse
                      data={this.loadTranscListing()}
                      />
                  </div>
                  
                  <div style={{ float: "right", marginTop: "-15px" }}>
                      <div className="d-flex align-items-center justify-content-end">
                          <div className="d-flex align-items-center">
                          <div role="status" aria-live="polite"> Rows per page:</div>
                          </div>
                          <div className="d-flex align-items-center" >
                          <select className=" d-flex align-items-center custom-select custom-select-sm form-control form-control-sm"
                                  onChange={(event) => {
                                      event.preventDefault();
                                      const { name, value } = event.target;
                                      //this.setState({ pageCount: value, setPage: 1 });
                                      this.setState(prevState => ({
                                              pageCount : value,
                                              setPage : 1,
                                          }),
                                          () => {
                                              this.getSaleListData(this.state.item_id,1,value);
                                          });
                                  }}>
                              <option value="25">25</option>
                              <option value="50">50</option>
                              <option value="100">100</option>
                              <option value="500">500</option>
                              <option value="1000">1000</option>
                          </select>
                          </div>
                          <div className="d-flex align-items-center">
                          <div role="status" aria-live="polite"> Total: {this.state.totalCount}</div>
                          </div>
                      </div>
                  </div>
                  <div className="block-content">
                      <div style={{ float: "left", marginTop: "-45px" }}>
                      <PaginationControl
                          between={this.state.pageCount}
                          total={this.state.totalCount}
                          limit={this.state.pageCount}
                          changePage={(page) => {
                          this.setState({ setPage: page });
                          this.getSaleListData(this.state.item_id,page,this.state.pageCount);
                          }}
                          ellipsis={1}
                          activeClass={this.state.setPage}
                          page={this.state.setPage}
                      />
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="global_loader" className={_loader}>
          <div className="gl-ldr-cld">
            <div className="gl-ldr-ctr">
              <div className="gl-loader"></div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
